import { Reveal } from "@/components/Reveal";

export default function Impressum() {
  return (
    <div data-testid="impressum-page" className="bg-[color:var(--cream)]">
      <section className="pt-40 lg:pt-48 pb-16 px-6 lg:px-10">
        <div className="mx-auto max-w-[1400px]">
          <div className="eyebrow mb-6">— Impressum</div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.95]">Impressum &amp; <em className="italic">rechtliche Angaben</em></h1>
        </div>
      </section>

      <section className="pb-24 px-6 lg:px-10">
        <div className="mx-auto max-w-[1400px] grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-6">
            <Block title="Kfz-Sachverständigenbüro Björn Linkowitz">
              Zimmermannsgasse 3<br />
              15366 Rennbahngemeinde Hoppegarten<br /><br />
              Telefon: +49.30.68 30 23 00<br />
              Telefax: +49.30.68 30 23 02<br />
              E-Mail: <a className="link-underline" href="mailto:info@classic-data.berlin">info@classic-data.berlin</a><br />
              Website: <a className="link-underline" href="https://www.classic-data.berlin">www.classic-data.berlin</a>
            </Block>

            <Block title="Rechtliche Angaben">
              Registergericht: AG Berlin<br />
              HRB-Nummer: —<br />
              Umsatzsteuer-ID: DE186729984<br />
              Inhaber: Björn Linkowitz
            </Block>

            <Block title="Vermögensschaden­haftpflichtversicherung">
              ERGO Versicherungsgruppe AG<br />
              Victoriaplatz 2<br />
              40198 Düsseldorf
            </Block>
          </Reveal>

          <Reveal className="lg:col-span-6" delay={0.1}>
            <Block title="Vertragspartner">
              <strong className="font-medium">BVSK e.V.</strong><br />
              Menzelstraße 5, 14467 Potsdam<br /><br />
              <strong className="font-medium">GTÜ Gesellschaft für Technische Überwachung mbH</strong><br />
              Vor dem Lauch 25, 70567 Stuttgart<br /><br />
              <strong className="font-medium">Classic Data Marktbeobachtung GmbH &amp; Co KG</strong><br />
              Harpener Str. 56, 44791 Bochum
            </Block>

            <Block title="Haftungshinweis">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
            </Block>

            <Block title="Bildnachweis">
              Sämtliche Fotos: © Björn Linkowitz / Kfz-Sachverständiger, Classic Data Berlin
            </Block>

            <Block title="Technische Betreuung und Pflege">
              team@work Systemhaus GmbH, Berlin · <a className="link-underline" href="https://teamatwork.de" target="_blank" rel="noreferrer">teamatwork.de</a>
            </Block>
          </Reveal>
        </div>
      </section>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div className="mb-10 pb-8 border-b border-black/10">
      <div className="text-[10px] tracking-[0.24em] uppercase text-[color:var(--burgundy)] mb-3">{title}</div>
      <div className="text-[15px] leading-[1.75] text-[color:var(--ink)]">{children}</div>
    </div>
  );
}
